import React, { useState } from "react";
import { Helmet } from "react-helmet";
import {
    Container,
    Row,
    Col,
    Form,
    Button,
    Alert,
    Card,
    Spinner,
    ButtonGroup
} from "react-bootstrap";
import Select from 'react-select';
import "bootstrap-icons/font/bootstrap-icons.css";
import NavBar from "../Components/NavBar/NavBar";
import Footer from "../Components/Footer/Footer";

const EMICancel = () => {
    const [formData, setFormData] = useState({
        referenceId: "",
        reason: null,
        otherReason: "",
        file: null,
    });
    const [submitted, setSubmitted] = useState(false);
    const [validated, setValidated] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const reasonOptions = [
        { value: "Changed my mind", label: "Changed my mind" },
        { value: "Incorrect EMI details", label: "Incorrect EMI details" },
        { value: "Prefer other payment method", label: "Prefer other payment method" },
        { value: "Other", label: "Other" }
    ];

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: files ? files[0] : value,
        }));
    };

    const handleReasonSelect = (selectedOption) => {
        setFormData(prev => ({
            ...prev,
            reason: selectedOption,
            otherReason: selectedOption?.value === "Other" ? prev.otherReason : ""
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.referenceId || !formData.reason ||
            (formData.reason.value === "Other" && !formData.otherReason)) {
            setValidated(true);
            return;
        }

        setIsLoading(true);
        setSubmitted(true);

        console.log("Cancellation Request:", {
            referenceId: formData.referenceId,
            reason: formData.reason.value,
            otherReason: formData.otherReason,
            file: formData.file
        });

        // try {
        //     const response = await axios.post(`${API_BASE_URL}/emi/cancel`, data, {
        //         headers: {
        //             'Content-Type': 'multipart/form-data',
        //             'Authorization': `Bearer ${localStorage.getItem('token')}`
        //         }
        //     });
        //     return response.data;
        // } catch (error) {
        //     throw error.response?.data?.message || 'Failed to submit cancellation request';
        // }

        // Simulate API call
        setTimeout(() => {
            setIsLoading(false);
            setTimeout(() => {
                setFormData({
                    referenceId: "",
                    reason: null,
                    otherReason: "",
                    file: null
                });
                setSubmitted(false);
                setValidated(false);
            }, 3000);
        }, 1500);
    };

    const handleReset = () => {
        setFormData({
            referenceId: "",
            reason: null,
            otherReason: "",
            file: null
        });
        setValidated(false);
    };

    const customStyles = {
        control: (base, { isFocused }) => ({
            ...base,
            fontSize: '14px',
            minHeight: '38px',
            borderColor: validated && !formData.reason ? '#dc3545' : isFocused ? '#2684FF' : '#ced4da',
            boxShadow: isFocused ? '0 0 0 1px #2684FF' : 'none',
            '&:hover': {
                borderColor: validated && !formData.reason ? '#dc3545' : isFocused ? '#2684FF' : '#ced4da'
            }
        }),
        menuPortal: base => ({ ...base, zIndex: 9999 }),
        menu: base => ({
            ...base,
            zIndex: 9999,
            fontSize: '14px'
        }),
        option: (base, { isSelected, isFocused }) => ({
            ...base,
            fontSize: '14px',
            backgroundColor: isSelected ? '#0d6efd' : isFocused ? '#f8f9fa' : 'white',
            color: isSelected ? 'white' : 'black',
            padding: '8px 12px',
        }),
        singleValue: base => ({
            ...base,
            fontSize: '14px'
        }),
        placeholder: base => ({
            ...base,
            fontSize: '14px'
        }),
        input: base => ({
            ...base,
            fontSize: '14px'
        }),
        dropdownIndicator: base => ({
            ...base,
            padding: '4px'
        })
    };

    return (
        <div className="d-flex flex-column min-vh-100" style={{
            background: "linear-gradient(135deg, #f8f9fa 0%, rgb(51, 151, 252) 100%)",
            fontSize: "14px"
        }}>
            <Helmet>
                <title>Cancel EMI Request | NexGen</title>
                <meta name="description" content="Request cancellation of your EMI payment plan" />
            </Helmet>

            <NavBar />

            <main className="flex-grow-1 py-5">
                <Container>
                    <Row className="justify-content-center text-center mb-3">
                        <Col xs={12} md={10} lg={8}>
                            <h1 className="fw-bold mb-2" style={{ fontSize: "clamp(16px, 5vw, 18px)" }}>
                                <i className="bi bi-x-circle-fill me-2"></i>
                                EMI Cancellation Request
                            </h1>
                            <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                                Fill out the form below to request EMI cancellation
                            </p>
                        </Col>
                    </Row>

                    <Row className="justify-content-center">
                        <Col xs={12} md={10} lg={8} xl={6}>
                            <Card className="border-0 shadow-sm">
                                <Card.Body className="p-3 p-md-4">
                                    {submitted && (
                                        <Alert variant="success" className="mb-4" style={{ fontSize: "14px" }}>
                                            <i className="bi bi-check-circle-fill me-2"></i>
                                            Cancellation request submitted successfully!
                                        </Alert>
                                    )}

                                    <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-medium" style={{ fontSize: "14px" }}>
                                                <i className="bi bi-upc-scan me-2"></i>
                                                EMI Reference ID
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="referenceId"
                                                placeholder="Enter your EMI ID"
                                                value={formData.referenceId}
                                                onChange={handleChange}
                                                required
                                                style={{ fontSize: "14px" }}
                                                isInvalid={validated && !formData.referenceId}
                                            />
                                            <Form.Control.Feedback type="invalid" style={{ fontSize: "13px" }}>
                                                Please enter your EMI reference ID.
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-medium" style={{ fontSize: "14px" }}>
                                                <i className="bi bi-chat-square-text me-2"></i>
                                                Cancellation Reason
                                            </Form.Label>
                                            <Select
                                                options={reasonOptions}
                                                value={formData.reason}
                                                onChange={handleReasonSelect}
                                                placeholder="Select reason"
                                                menuPortalTarget={document.body}
                                                styles={customStyles}
                                                isSearchable={false}
                                                tabSelectsValue={true}
                                                openMenuOnFocus={true}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter' && !formData.reason) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                components={{
                                                    IndicatorSeparator: () => null
                                                }}
                                            />
                                            {validated && !formData.reason && (
                                                <div className="invalid-feedback" style={{ display: "block", fontSize: "13px" }}>
                                                    Please select a reason.
                                                </div>
                                            )}
                                        </Form.Group>

                                        {formData.reason?.value === "Other" && (
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-medium" style={{ fontSize: "14px" }}>
                                                    <i className="bi bi-pencil me-2"></i>
                                                    Please specify your reason
                                                </Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    name="otherReason"
                                                    placeholder="Enter your reason here..."
                                                    value={formData.otherReason}
                                                    onChange={handleChange}
                                                    required
                                                    style={{ fontSize: "14px", minHeight: "80px" }}
                                                    isInvalid={validated && !formData.otherReason}
                                                />
                                                <Form.Control.Feedback type="invalid" style={{ fontSize: "13px" }}>
                                                    Please specify your reason.
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        )}

                                        <Form.Group className="mb-4">
                                            <Form.Label className="fw-medium" style={{ fontSize: "14px" }}>
                                                <i className="bi bi-paperclip me-2"></i>
                                                Upload Supporting File (Optional)
                                            </Form.Label>
                                            <Form.Control
                                                type="file"
                                                name="file"
                                                accept=".pdf,.jpg,.png"
                                                onChange={handleChange}
                                                style={{ fontSize: "14px" }}
                                            />
                                        </Form.Group>

                                        <ButtonGroup className="w-100 gap-2">
                                            <Button
                                                type="submit"
                                                variant="danger"
                                                className="fw-medium flex-grow-1"
                                                disabled={isLoading}
                                                style={{ fontSize: "14px", padding: "8px 16px" }}
                                            >
                                                {isLoading ? (
                                                    <>
                                                        <Spinner
                                                            as="span"
                                                            animation="border"
                                                            size="sm"
                                                            className="me-2"
                                                        />
                                                        Submitting...
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="bi bi-send-fill me-2"></i>
                                                        Submit Request
                                                    </>
                                                )}
                                            </Button>

                                            {(formData.referenceId || formData.reason || formData.file) && (
                                                <Button
                                                    variant="outline-secondary"
                                                    onClick={handleReset}
                                                    style={{ fontSize: "14px", padding: "8px 16px" }}
                                                >
                                                    <i className="bi bi-arrow-counterclockwise me-2"></i>
                                                    Reset
                                                </Button>
                                            )}
                                        </ButtonGroup>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </main>

            <Footer />
        </div>
    );
};

export default EMICancel;